// extracted by mini-css-extract-plugin
export default {"container":"TrailingBadge-module__container--gg6pc","label":"TrailingBadge-module__label--F7ho5","title":"TrailingBadge-module__title--FDayi"};